var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProhibitedSymbol = function SvgProhibitedSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D83A3A",
    strokeWidth: 3,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 126,
    r: 126
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "m35.5 38.5 177.872 177.872"
  }))));
};
export default SvgProhibitedSymbol;